/* eslint-disable */
import ko from 'knockout';

export default class ViewModel {
  constructor() {
    this.showTesting = ko.observable();
    this.resultType = ko.observable();
    this.resultString = ko.observable();
  }
};